

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';
import { forwardRef } from 'react';
// Shared components

import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import 'react-perfcascade/dist/react-perfcascade.css';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
// Component styles
import { api_host, api_auth } from './../../../../common/globals/constants';
import moment from 'moment'
import 'moment/locale/es'
import Hours from './../../../../helpers/Hours';
import HoursEdit from './../../../../helpers/HoursEdit';
import {getClientWeighing} from './../../../../services/getClientWeighing';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { TableCell, Table, TableRow, TablePagination, TableHead } from '@material-ui/core';

import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField/index';
import Grid from '@material-ui/core/Grid';
moment.locale('es')
const dateMoment=((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))

const sendValues = (nombre, descripcion, token, user, horarioId) => {

    return new Promise(resolve => {
        setTimeout(() => {
        fetch(api_host+`/reporte/general/horarios_habiles/?token=${token}`, {
            method: 'DELETE', // or 'PUT'
            body: JSON.stringify({token: token, nombre: nombre, descripcion: descripcion, cliente_id: user, horario_id: horarioId}), // data can be `string` or {object}!
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => res.json())
            .catch(error => console.error('Error:', error))
            .then(response => {
                if (response.status == 1) {
                    resolve(false);
                } else {
                    resolve(true);
                }
            }
            );
        }, 100);
    });
};

class ClientWeighing extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            isLoad:true,
            objective:this.props.objective,
            nodes:this.props.nodes,
            steps:this.props.steps,
            begin:this.props.dateBegin,
            final:this.props.dateFinal,
            dates:null,
            modalOpen:false,
            //onClose:this.props.onClose,
            completed: false,
            open: false,
            values:{
                name: '',
                interval: 1,
                intervalHour: '01:00:00'
            },
            openSnack: false,
            isValid: false,
            page: 0,
            pages: 1,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dateBegin !== state.begin||props.dateFinal!==state.final) {
            return {
                isLoad:true,
                begin:props.dateBegin,
                final:props.dateFinal,
                dates:null
            }
        }
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if(prevState.open !== this.state.open || prevState.editEl !== this.state.editEl){
            this.processData();
        }
    }

    componentDidMount() {
        this.processData();
    }

    getFetchs = (user, token, type) =>{         
        var getData = getClientWeighing(user, token, type)           
        getData.then( data =>  { 
            console.log(data[0].items.length)
            var interval = 1
            var intervalHour = ':00:00'
            /*if (data[0].items.length == 24){
                interval = 1
                intervalHour = '01'+intervalHour
            } else if (data[0].items.length == 12){
                interval = 2
                intervalHour = '02'+intervalHour
            } else if (data[0].items.length == 8){
                interval = 3
                intervalHour = '03'+intervalHour
            } else if (data[0].items.length == 6){
                interval = 4
                intervalHour = '04'+intervalHour
            } else if (data[0].items.length == 4){
                interval = 6
                intervalHour = '06'+intervalHour
            } else if (data[0].items.length == 3){
                interval = 8
                intervalHour = '08'+intervalHour
            } else if (data[0].items.length == 2){
                interval = 12
                intervalHour = '12'+intervalHour
            }*/
            if (data[0].intervalo == 1){
                interval = 1
                intervalHour = '01'+intervalHour
            } else if (data[0].intervalo == 2){
                interval = 2
                intervalHour = '02'+intervalHour
            } else if (data[0].intervalo == 3){
                interval = 3
                intervalHour = '03'+intervalHour
            } else if (data[0].intervalo == 4){
                interval = 4
                intervalHour = '04'+intervalHour
            } else if (data[0].intervalo == 6){
                interval = 6
                intervalHour = '06'+intervalHour
            } else if (data[0].intervalo == 8){
                interval = 8
                intervalHour = '08'+intervalHour
            } else if (data[0].intervalo == 12){
                interval = 12
                intervalHour = '12'+intervalHour
            }
            this.setState({
                isLoad:false,
                data:data,
                values:{
                    name: '',
                    interval: interval,
                    intervalHour: intervalHour
                },
                validNumber: false
            })
        })      
        
    }
   
    processData = () => {
        const { objective, begin, final} = this.state
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        let type = 5
        this.getFetchs(user, token, type)
    }

    /*setOpen = (audio) => {
        this.setState({
            modalOpen : true,
            modalClose : false,
            setAudio : audio,
        })
    }
    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true,
            setAudio : null
        })
    }*/

    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    handleShowEdit = (event, value) => {
        this.setState({
            editEl: event.currentTarget,
            valuesEdit: value
        });
    };

    onCloseModalEdit = () => {
        this.setState({ editEl: null });
    };

    handleShowDelete = (event, value) => {
        this.setState({
            deleteEl: event.currentTarget,
            values:{
                name: value.nombre,
                descripcion: value.descripcion,
                horarioId: value.horario_id
            }
        });
    };

    handleCloseDelete = () => {
        this.setState({
            deleteEl: null
        });
    };

    handleDeleted = async(value) => {
        const {addEl, editEl, values} = this.state;
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('client_id')
        try {
            this.setState({ isLoading: true });
            var ok = await sendValues(values.nombre, values.descripcion, token, user, values.horarioId);
            if (ok){
                this.setState({
                    isLoading: true,
                    isValid: true,                   
                    open: false,
                    deleteEl: null,
                    openSnack: true,

                });
                this.processData();
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    open: false,
                    openSnack: true,
                });
                
            }

        } catch (error) {
            this.setState({
                isLoading: false,
                //serviceError: error,
                isValid: false,
                open: false,
                openSnack: true,
            });
        }
    }
    handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            openSnack: false 
        })
    };
    handleOpenSnack = (reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            openSnack: true,
            isValid: reason 
        })
    };

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.values[field] = value;     
        this.setState(newState);
    };
    validateNumber = (number) => {
        if (!number) {
            this.setState({
                validNumber: true,
            });
        } else {
            this.setState({
                validNumber: false,
            });
        }
    }
    render() {

        const { isLoad, data, steps, objective, modalOpen, onClose, completed, open, editEl, valuesEdit, 
                deleteEl, values, openSnack, isValid, page, validNumber} = this.state;
        const { classes } = this.props;
        const showModal = Boolean(open); 
        const showModalEdit = Boolean(editEl); 
        const showDeleteEl = Boolean(deleteEl);
        console.log(values.intervalHour)
        return(<Portlet style={{maxHeight:440}}>
                <PortletHeader style={{color:'white'}}>
                    <FormControl style={{width:"130px"}} >   
                        <InputLabel htmlFor="age-native-helper" variant="h5"> Intervalo de división</InputLabel>
                        <NativeSelect
                            name="type"
                            variant="outlined"
                            //style={{paddingLeft:"70px"}}
                            value={values.interval}
                            onChange={event =>
                                this.handleFieldChange('interval', event.target.value)
                            }
                        >
                            <option value={1}>{'1 Hora'}</option>
                            <option value={2}>{'2 Horas'}</option>
                            <option value={3}>{'3 Horas'}</option>
                            <option value={4}>{'4 Horas'}</option>
                            <option value={6}>{'6 Horas'}</option>
                            <option value={8}>{'8 Horas'}</option>
                            <option value={12}>{'12 Horas'}</option>

                        </NativeSelect>
                    </FormControl>
                </PortletHeader>
                { data == null  ? 
                    <PortletContent style={{alignItems: 'center', position: 'absolute', top: '20%', left: '50%'}}>
                        <PerfectScrollbar>
                            <Typography
                            variant="h5"
                            style={{color:'white'}}
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={24}
                            thickness={4}
                            />
                            <br/>
                                Cargando Información...
                            </Typography>
                        </PerfectScrollbar>
                    </PortletContent>
                :<PortletContent style={{maxHeight:440, overflow:'auto'}}>
                            <Table stickyHeader size="small" >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{"Inicio"}</TableCell>
                                        <TableCell>{"Termino"}</TableCell>
                                        <TableCell>{"Intervalo"}</TableCell>
                                        <TableCell>{"Ponderación"}</TableCell>
                                    </TableRow>
                                </TableHead>
                                {data[0].items.map(obj=>(
                                    <TableRow>
                                        <TableCell>{obj.inicio}</TableCell>
                                        <TableCell>{obj.termino}</TableCell>
                                        <TableCell>{values.intervalHour}</TableCell>
                                        <TableCell>{<Grid style={{width:"30%"}} container wrap="nowrap" spacing={1} justify="flex-start" alignItems="center">
                                                        <Grid item xs>
                                                            <TextField
                                                                //className={classes.textField}
                                                                //label=""
                                                                size="small"
                                                                name="value"
                                                                value={obj.valor}
                                                                onChange={event =>
                                                                    this.handleFieldChange('value', event.target.value)
                                                                }
                                                                type="numeric"
                                                                //required
                                                                /*onBlur={event =>
                                                                    this.validateNumber(event.target.value)
                                                                }*/
                                                                //defaultValue={values.nameEdit}
                                                                /*error={validNumber}
                                                                helperText={validNumber ? 'Por favor ingrese un valor válido' : ' '}*/
                                                                variant="outlined"
                                                                //inputProps={{maxLength :40}}
                                                            />
                                                        </Grid>
                                                        <Grid item xs>
                                                            %
                                                        </Grid>
                                                    </Grid>
                                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </Table>  
                    </PortletContent>
                }
            </Portlet>
        ) 
    }
}



export default compose(withRouter, withStyles(styles))(ClientWeighing);